import { useHistory } from 'react-router';

export const useDividendsMode = () => {
  const history = useHistory();
  return history.location.search.includes('dividends=true');
};
